import { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

interface Props {
  id: string;
  error: ReactNode;
}

const ErrorText: FC<Props> = ({ id, error }: Props): JSX.Element | null => {
  if (!error) {
    return null;
  }

  return (
    <span id={id} className={styles.error}>
      {error}
    </span>
  );
};

export default ErrorText;
